/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { Movimiento } from '../model/movimiento';
import { Persona } from '../model/persona';
import { Reserva } from '../model/reserva';
import { ReservaBase } from '../model/reservaBase';
import { ReservaPatch } from '../model/reservaPatch';
import { TipoReserva } from '../model/tipoReserva';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ReservasService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Elimina o cancela una reserva.
     * Elimina o cancela una reserva.
     * @param empresaId Especifica la empresaid.
     * @param reservaId El id de una reserva a eliminar asociado al evento y a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEmpresasBydReservaById(empresaId: string, reservaId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteEmpresasBydReservaById(empresaId: string, reservaId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteEmpresasBydReservaById(empresaId: string, reservaId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteEmpresasBydReservaById(empresaId: string, reservaId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling deleteEmpresasBydReservaById.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling deleteEmpresasBydReservaById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.delete<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/${encodeURIComponent(String(reservaId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * La lista de reservas para una actividaf en un dia en especifica.
     * La lista de reservas para una actividaf en un dia en especifica.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param yyyymmdd La fecha de la programacion.
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdActividadesByIdReservas(empresaId: string, actividadId: string, yyyymmdd: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Reserva>>;
    public getEmpresasByIdActividadesByIdReservas(empresaId: string, actividadId: string, yyyymmdd: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Reserva>>>;
    public getEmpresasByIdActividadesByIdReservas(empresaId: string, actividadId: string, yyyymmdd: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Reserva>>>;
    public getEmpresasByIdActividadesByIdReservas(empresaId: string, actividadId: string, yyyymmdd: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdActividadesByIdReservas.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getEmpresasByIdActividadesByIdReservas.');
        }
        if (yyyymmdd === null || yyyymmdd === undefined) {
            throw new Error('Required parameter yyyymmdd was null or undefined when calling getEmpresasByIdActividadesByIdReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Reserva>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/programaciones/${encodeURIComponent(String(yyyymmdd))}/reservas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene las reservas que han sido canceladas con o sin movimientos.
     * Obiene las reservas que han sido modificadas o tienen movimientos nuevos.
     * @param empresaId Especifica la empresaid.
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param tipo Permite definir el tipo de la reserva.
     * @param fdesde Fecha desde donde se debe hacer la consulta.
     * @param fhasta Fechas hasta inclusive.
     * @param zoffset Especifica la zona para el calculo de las fechas.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdCancelacionesReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, fdesde?: string, fhasta?: string, zoffset?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Reserva>>;
    public getEmpresasByIdCancelacionesReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, fdesde?: string, fhasta?: string, zoffset?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Reserva>>>;
    public getEmpresasByIdCancelacionesReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, fdesde?: string, fhasta?: string, zoffset?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Reserva>>>;
    public getEmpresasByIdCancelacionesReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, fdesde?: string, fhasta?: string, zoffset?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdCancelacionesReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }
        if (tipo !== undefined && tipo !== null) {
            queryParameters = queryParameters.set('tipo', <any>tipo);
        }
        if (fdesde !== undefined && fdesde !== null) {
            queryParameters = queryParameters.set('fdesde', <any>fdesde);
        }
        if (fhasta !== undefined && fhasta !== null) {
            queryParameters = queryParameters.set('fhasta', <any>fhasta);
        }
        if (zoffset !== undefined && zoffset !== null) {
            queryParameters = queryParameters.set('zoffset', <any>zoffset);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Reserva>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas-canceladas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * La lista de reservas para una evento en especifica
     * Los eventos.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdEventosByIdReservas(empresaId: string, eventoId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Reserva>>;
    public getEmpresasByIdEventosByIdReservas(empresaId: string, eventoId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Reserva>>>;
    public getEmpresasByIdEventosByIdReservas(empresaId: string, eventoId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Reserva>>>;
    public getEmpresasByIdEventosByIdReservas(empresaId: string, eventoId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdEventosByIdReservas.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling getEmpresasByIdEventosByIdReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Reserva>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/reservas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene las pre-reservas de una empresa.
     * Obtiene las pre-reservas de una empresa.
     * @param empresaId Especifica la empresaid.
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param tipo Permite definir el tipo de la reserva.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdPreReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, observe?: 'body', reportProgress?: boolean): Observable<Array<Reserva>>;
    public getEmpresasByIdPreReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Reserva>>>;
    public getEmpresasByIdPreReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Reserva>>>;
    public getEmpresasByIdPreReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdPreReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }
        if (tipo !== undefined && tipo !== null) {
            queryParameters = queryParameters.set('tipo', <any>tipo);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Reserva>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/prereservas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene las reservas de una empresa.
     * Obtiene las reservas de una empresa.
     * @param empresaId Especifica la empresaid.
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Reserva>>;
    public getEmpresasByIdReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Reserva>>>;
    public getEmpresasByIdReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Reserva>>>;
    public getEmpresasByIdReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Reserva>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene las reservas de una empresa por su codigo.
     * Obtiene las reservas de una empresa por su codigo.
     * @param empresaId Especifica la empresaid.
     * @param codigo Codigo de la reserva.
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdReservasByCodigo(empresaId: string, codigo: number, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public getEmpresasByIdReservasByCodigo(empresaId: string, codigo: number, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public getEmpresasByIdReservasByCodigo(empresaId: string, codigo: number, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public getEmpresasByIdReservasByCodigo(empresaId: string, codigo: number, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdReservasByCodigo.');
        }
        if (codigo === null || codigo === undefined) {
            throw new Error('Required parameter codigo was null or undefined when calling getEmpresasByIdReservasByCodigo.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Reserva>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/by-codigo/${encodeURIComponent(String(codigo))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista los movimientos de una reserva
     * Los movimientos de una reserva
     * @param empresaId Especifica la empresaid.
     * @param reservaId El id de una reserva a eliminar asociado al evento y a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdReservasByIdMovimientos(empresaId: string, reservaId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Movimiento>>;
    public getEmpresasByIdReservasByIdMovimientos(empresaId: string, reservaId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Movimiento>>>;
    public getEmpresasByIdReservasByIdMovimientos(empresaId: string, reservaId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Movimiento>>>;
    public getEmpresasByIdReservasByIdMovimientos(empresaId: string, reservaId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdReservasByIdMovimientos.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling getEmpresasByIdReservasByIdMovimientos.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Movimiento>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/${encodeURIComponent(String(reservaId))}/movimientos/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * El movimiento de una reserva por su indice
     * El movimiento de una reserva por su indice
     * @param empresaId Especifica la empresaid.
     * @param reservaId El id de una reserva a eliminar asociado al evento y a la empresa.
     * @param movimientoIndex El indice del movimiento.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdReservasByIdMovimientosByIndex(empresaId: string, reservaId: string, movimientoIndex: number, observe?: 'body', reportProgress?: boolean): Observable<Movimiento>;
    public getEmpresasByIdReservasByIdMovimientosByIndex(empresaId: string, reservaId: string, movimientoIndex: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Movimiento>>;
    public getEmpresasByIdReservasByIdMovimientosByIndex(empresaId: string, reservaId: string, movimientoIndex: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Movimiento>>;
    public getEmpresasByIdReservasByIdMovimientosByIndex(empresaId: string, reservaId: string, movimientoIndex: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdReservasByIdMovimientosByIndex.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling getEmpresasByIdReservasByIdMovimientosByIndex.');
        }
        if (movimientoIndex === null || movimientoIndex === undefined) {
            throw new Error('Required parameter movimientoIndex was null or undefined when calling getEmpresasByIdReservasByIdMovimientosByIndex.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Movimiento>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/${encodeURIComponent(String(reservaId))}/movimientos/${encodeURIComponent(String(movimientoIndex))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de personas de una reserva.
     * Obtiene la lista de personas de una reserva.
     * @param empresaId Especifica la empresaid.
     * @param reservaId El id de una reserva a eliminar asociado al evento y a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasByIdReservasByIdPersonas(empresaId: string, reservaId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Persona>>;
    public getEmpresasByIdReservasByIdPersonas(empresaId: string, reservaId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Persona>>>;
    public getEmpresasByIdReservasByIdPersonas(empresaId: string, reservaId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Persona>>>;
    public getEmpresasByIdReservasByIdPersonas(empresaId: string, reservaId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasByIdReservasByIdPersonas.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling getEmpresasByIdReservasByIdPersonas.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Persona>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/${encodeURIComponent(String(reservaId))}/personas/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obiene las reservas que han sido modificadas o tienen movimientos nuevos.
     * Obiene las reservas que han sido modificadas o tienen movimientos nuevos.
     * @param empresaId Especifica la empresaid.
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param tipo Permite definir el tipo de la reserva.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasBydNotificacionReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, observe?: 'body', reportProgress?: boolean): Observable<Array<Reserva>>;
    public getEmpresasBydNotificacionReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Reserva>>>;
    public getEmpresasBydNotificacionReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Reserva>>>;
    public getEmpresasBydNotificacionReservas(empresaId: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, tipo?: TipoReserva, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasBydNotificacionReservas.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }
        if (tipo !== undefined && tipo !== null) {
            queryParameters = queryParameters.set('tipo', <any>tipo);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Reserva>>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/notificacion-reservas/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene el detalle de una reserva.
     * Obtiene el detalle de una reserva.
     * @param empresaId Especifica la empresaid.
     * @param reservaId El id de una reserva a eliminar asociado al evento y a la empresa.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmpresasBydReservaById(empresaId: string, reservaId: string, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public getEmpresasBydReservaById(empresaId: string, reservaId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public getEmpresasBydReservaById(empresaId: string, reservaId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public getEmpresasBydReservaById(empresaId: string, reservaId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling getEmpresasBydReservaById.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling getEmpresasBydReservaById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Reserva>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/${encodeURIComponent(String(reservaId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * El movimiento de una reserva por su indice
     * El movimiento de una reserva por su indice
     * @param usuario El usuario de kogui.
     * @param reservaId El id de una reserva asociado al usuario.
     * @param movimientoIndex El indice del movimiento.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioReservasByIdMovimientosByIndex(usuario: string, reservaId: string, movimientoIndex: number, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Movimiento>;
    public getKoguiByUsuarioReservasByIdMovimientosByIndex(usuario: string, reservaId: string, movimientoIndex: number, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Movimiento>>;
    public getKoguiByUsuarioReservasByIdMovimientosByIndex(usuario: string, reservaId: string, movimientoIndex: number, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Movimiento>>;
    public getKoguiByUsuarioReservasByIdMovimientosByIndex(usuario: string, reservaId: string, movimientoIndex: number, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioReservasByIdMovimientosByIndex.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling getKoguiByUsuarioReservasByIdMovimientosByIndex.');
        }
        if (movimientoIndex === null || movimientoIndex === undefined) {
            throw new Error('Required parameter movimientoIndex was null or undefined when calling getKoguiByUsuarioReservasByIdMovimientosByIndex.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Movimiento>(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/${encodeURIComponent(String(reservaId))}/movimientos/${encodeURIComponent(String(movimientoIndex))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * El adjunto de un movimiento de una reserva por su indice
     * El adjunto de un movimiento de una reserva por su indice
     * @param usuario El usuario de kogui.
     * @param reservaId El id de una reserva asociado al usuario.
     * @param movimientoIndex El indice del movimiento.
     * @param attachment Especifica el disposition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiByUsuarioReservasByIdMovimientosByIndexAdjunto(usuario: string, reservaId: string, movimientoIndex: number, attachment?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getKoguiByUsuarioReservasByIdMovimientosByIndexAdjunto(usuario: string, reservaId: string, movimientoIndex: number, attachment?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getKoguiByUsuarioReservasByIdMovimientosByIndexAdjunto(usuario: string, reservaId: string, movimientoIndex: number, attachment?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getKoguiByUsuarioReservasByIdMovimientosByIndexAdjunto(usuario: string, reservaId: string, movimientoIndex: number, attachment?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (usuario === null || usuario === undefined) {
            throw new Error('Required parameter usuario was null or undefined when calling getKoguiByUsuarioReservasByIdMovimientosByIndexAdjunto.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling getKoguiByUsuarioReservasByIdMovimientosByIndexAdjunto.');
        }
        if (movimientoIndex === null || movimientoIndex === undefined) {
            throw new Error('Required parameter movimientoIndex was null or undefined when calling getKoguiByUsuarioReservasByIdMovimientosByIndexAdjunto.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (attachment !== undefined && attachment !== null) {
            queryParameters = queryParameters.set('attachment', <any>attachment);
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*',
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/kogui/usuarios/${encodeURIComponent(String(usuario))}/reservas/${encodeURIComponent(String(reservaId))}/movimientos/${encodeURIComponent(String(movimientoIndex))}/adjunto`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param empresaId Especifica la empresaid.
     * @param reservaId El id de una reserva a eliminar asociado al evento y a la empresa.
     * @param reservaPatch Solicitud de Patch sobre la reserva.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchEmpresasBydReservaById(empresaId: string, reservaId: string, reservaPatch?: ReservaPatch, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public patchEmpresasBydReservaById(empresaId: string, reservaId: string, reservaPatch?: ReservaPatch, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public patchEmpresasBydReservaById(empresaId: string, reservaId: string, reservaPatch?: ReservaPatch, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public patchEmpresasBydReservaById(empresaId: string, reservaId: string, reservaPatch?: ReservaPatch, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling patchEmpresasBydReservaById.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling patchEmpresasBydReservaById.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/${encodeURIComponent(String(reservaId))}`,
            reservaPatch,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una nueva reserva asociado a la actividad.
     * Aparte el cupo reservando par la actividad.
     * @param empresaId Especifica la empresaid.
     * @param actividadId El id de un evento asociado a la empresa.
     * @param yyyymmdd La fecha de la programacion.
     * @param reservaBase Reserva Request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEmpresasByIdActividadesByIdReservas(empresaId: string, actividadId: string, yyyymmdd: string, reservaBase: ReservaBase, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public postEmpresasByIdActividadesByIdReservas(empresaId: string, actividadId: string, yyyymmdd: string, reservaBase: ReservaBase, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public postEmpresasByIdActividadesByIdReservas(empresaId: string, actividadId: string, yyyymmdd: string, reservaBase: ReservaBase, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public postEmpresasByIdActividadesByIdReservas(empresaId: string, actividadId: string, yyyymmdd: string, reservaBase: ReservaBase, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling postEmpresasByIdActividadesByIdReservas.');
        }
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling postEmpresasByIdActividadesByIdReservas.');
        }
        if (yyyymmdd === null || yyyymmdd === undefined) {
            throw new Error('Required parameter yyyymmdd was null or undefined when calling postEmpresasByIdActividadesByIdReservas.');
        }
        if (reservaBase === null || reservaBase === undefined) {
            throw new Error('Required parameter reservaBase was null or undefined when calling postEmpresasByIdActividadesByIdReservas.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Reserva>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/actividades/${encodeURIComponent(String(actividadId))}/programaciones/${encodeURIComponent(String(yyyymmdd))}/reservas/`,
            reservaBase,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea una nueva reserva asociado al evento.
     * Aparte el cupo reservando par ael evento.
     * @param empresaId Especifica la empresaid.
     * @param eventoId El id de un evento asociado a la empresa.
     * @param reservaBase Reserva Request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEmpresasByIdEventosByIdReservas(empresaId: string, eventoId: string, reservaBase: ReservaBase, observe?: 'body', reportProgress?: boolean): Observable<Reserva>;
    public postEmpresasByIdEventosByIdReservas(empresaId: string, eventoId: string, reservaBase: ReservaBase, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Reserva>>;
    public postEmpresasByIdEventosByIdReservas(empresaId: string, eventoId: string, reservaBase: ReservaBase, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Reserva>>;
    public postEmpresasByIdEventosByIdReservas(empresaId: string, eventoId: string, reservaBase: ReservaBase, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling postEmpresasByIdEventosByIdReservas.');
        }
        if (eventoId === null || eventoId === undefined) {
            throw new Error('Required parameter eventoId was null or undefined when calling postEmpresasByIdEventosByIdReservas.');
        }
        if (reservaBase === null || reservaBase === undefined) {
            throw new Error('Required parameter reservaBase was null or undefined when calling postEmpresasByIdEventosByIdReservas.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Reserva>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/eventos/${encodeURIComponent(String(eventoId))}/reservas/`,
            reservaBase,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Agrega un nuevo movimiento a la lista de movimientos
     * Agrega un nuevo movimiento a la lista de movimientos con el estado OK
     * @param empresaId Especifica la empresaid.
     * @param reservaId El id de una reserva a eliminar asociado al evento y a la empresa.
     * @param monto Monto del movimiento registrado.
     * @param fecha Fecha del movimiento registrado.
     * @param notas Nota o comentario sobre el movimiento.
     * @param adjunto Adjunto con informacion o comporbante de pago
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEmpresasByIdReservasByIdMovimientos(empresaId: string, reservaId: string, monto: number, fecha: Date, notas: string, adjunto?: Blob, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postEmpresasByIdReservasByIdMovimientos(empresaId: string, reservaId: string, monto: number, fecha: Date, notas: string, adjunto?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postEmpresasByIdReservasByIdMovimientos(empresaId: string, reservaId: string, monto: number, fecha: Date, notas: string, adjunto?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postEmpresasByIdReservasByIdMovimientos(empresaId: string, reservaId: string, monto: number, fecha: Date, notas: string, adjunto?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling postEmpresasByIdReservasByIdMovimientos.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling postEmpresasByIdReservasByIdMovimientos.');
        }
        if (monto === null || monto === undefined) {
            throw new Error('Required parameter monto was null or undefined when calling postEmpresasByIdReservasByIdMovimientos.');
        }
        if (fecha === null || fecha === undefined) {
            throw new Error('Required parameter fecha was null or undefined when calling postEmpresasByIdReservasByIdMovimientos.');
        }
        if (notas === null || notas === undefined) {
            throw new Error('Required parameter notas was null or undefined when calling postEmpresasByIdReservasByIdMovimientos.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (monto !== undefined) {
            formParams = formParams.append('monto', <any>monto) as any || formParams;
        }
        if (fecha !== undefined) {
            formParams = formParams.append('fecha', <any>fecha) as any || formParams;
        }
        if (notas !== undefined) {
            formParams = formParams.append('notas', <any>notas) as any || formParams;
        }
        if (adjunto !== undefined) {
            formParams = formParams.append('adjunto', <any>adjunto) as any || formParams;
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/${encodeURIComponent(String(reservaId))}/movimientos/`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Estable las personas de una reserva.
     * @param empresaId Especifica la empresaid.
     * @param reservaId El id de una reserva a eliminar asociado al evento y a la empresa.
     * @param persona 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putEmpresasByIdReservasByIdPersonas(empresaId: string, reservaId: string, persona?: Array<Persona>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public putEmpresasByIdReservasByIdPersonas(empresaId: string, reservaId: string, persona?: Array<Persona>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public putEmpresasByIdReservasByIdPersonas(empresaId: string, reservaId: string, persona?: Array<Persona>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public putEmpresasByIdReservasByIdPersonas(empresaId: string, reservaId: string, persona?: Array<Persona>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (empresaId === null || empresaId === undefined) {
            throw new Error('Required parameter empresaId was null or undefined when calling putEmpresasByIdReservasByIdPersonas.');
        }
        if (reservaId === null || reservaId === undefined) {
            throw new Error('Required parameter reservaId was null or undefined when calling putEmpresasByIdReservasByIdPersonas.');
        }

        let headers = this.defaultHeaders;

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/empresas/${encodeURIComponent(String(empresaId))}/reservas/${encodeURIComponent(String(reservaId))}/personas/`,
            persona,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
